export * from './lib/directives-skeleton.module';
